module.exports = __webpack_public_path__ + "img/reward_reach_04.55656da9.png";